import React, {Component} from 'react';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';

export class MetaDataWrapper extends Component {

    constructor(props) {
        super(props);

        const metaData = this.getMetaDataFromProps(props.pathname, props);

        this.state = {...metaData};
    }

    componentDidMount() {
        if (window.location && window.location.pathname) {
            this.setMetaDataStateFromPathname(window.location.pathname, this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (window.location && window.location.pathname) {
            this.setMetaDataStateFromPathname(window.location.pathname, nextProps);
        }       
    }

    getTitle(meta, props) {
        if (meta && meta.title) {
            return meta.title;
        }

        if (props.title) {
            return props.title;
        }

        if (props.helmetProps && props.helmetProps.title) {
            return props.helmetProps.title;
        }

        return '';
    }

    getOverridingMetaDataValue(meta, name) {
        if (meta[name] && meta[name].length > 0) {
            return meta[name];
        }

        return '';        
    }

    getMetaDataFromProps(pathname, props) {
        const meta = this.getMetaDataByPathname(pathname, props.metadata);
        const title = this.getTitle(meta, props); 
        const description = this.getOverridingMetaDataValue(meta, "description");
        const keywords = this.getOverridingMetaDataValue(meta, "keywords");

        return {title, description, keywords};
    }

    setMetaDataStateFromPathname(pathname, props) {
        const metaData = this.getMetaDataFromProps(pathname, props);

        this.setState(metaData);
    }

    getMetaDataByPathname(path, metadata) {
        if (!metadata || metadata.length === 0) {
            return false;
        }

        const meta = metadata.filter(m => m.path === path);

        return meta[0] || false;
    }

    renderMetaTag(props) {
        if (props.content && props.content.length > 0) {
            return (
                <meta {...props} />
            );
        }

        return null;
    }

    render() {
        return (
            <Helmet {...this.props.helmetProps} >
                {this.state.title && this.state.title.length >0 ? 
                    <title>{this.state.title}</title> : ''}
                {this.renderMetaTag({name: "description", content: this.state.description})}
                {this.renderMetaTag({name: "keywords", content: this.state.keywords})}
                {this.props.children}
            </Helmet>
        );
    }
}

export default connect((state) => {
    const metadata = state.common && state.common.metaData 
        && state.common.metaData.entries ? state.common.metaData.entries : [];

    const pathname = (state.routing && state.routing.locationBeforeTransitions 
        && state.routing.locationBeforeTransitions.pathname) ? state.routing.locationBeforeTransitions.pathname : '';
        
    return {
        metadata,
        pathname
    }
})(MetaDataWrapper);


// WEBPACK FOOTER //
// ./modules/Common/containers/MetaDataWrapper.js